<template>
  <div id="account-profile-more" class="pt-5">
    <h1 class="card-title mb-4">{{ $t('views.myAccount.moreOptions') }}</h1>

    <base-material-alert v-if="error" color="softError" class="secondary--text">
      <span v-if="error">
        {{ $t(`views.sign.${error}`) }}
      </span>
    </base-material-alert>

    <!-- change password: only not provider -->
    <div v-if="!isProvider">
      <p class="mb-2">
        <a @click="changePassword">
          {{ $t('views.myAccount.changePasswordTitle') }}
        </a>
      </p>
      <v-row v-if="changingPassword" class="align-center">
        <v-col cols="6" sm="6" class="py-0 mb-0 mt-2">
          <v-text-field
            v-model="newPassword"
            :label="$t('views.myAccount.newPassword')"
            :disabled="myLoading"
            class="mt-2 pt-0"
            type="password"
            hide-details
          />
          <v-text-field
            v-model="newPasswordRepeat"
            :label="$t('views.myAccount.newPasswordRepeat')"
            type="password"
            class="mt-6 pt-0"
            :disabled="myLoading"
            hide-details
          />
          <div class="mt-6 mb-6 d-flex">
            <v-btn class="mr-2" :disabled="myLoading" small @click="resetPasswordForm">
              {{ $t('common.cancel') }}
            </v-btn>
            <v-btn
              color="primary"
              class="mr-0"
              :loading="myLoading"
              small
              :disabled="!newPassword || !newPasswordRepeat"
              @click="updatePassword"
            >
              {{ $t('views.myAccount.updatePassword') }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
    <!-- change password: only not provider -->
    <p>
      <a @click="deleteAccount">{{ $t('views.myAccount.deleteAccount.title') }}</a>
    </p>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import { mapActions } from 'vuex'
import { deleteUser } from '@/lib/api.js'
import BillingMixin from '@/views/components/account/BillingMixin.js'

export default {
  mixins: [BillingMixin],
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      myLoading: false,
      changingPassword: false,
      newPassword: null,
      newPasswordRepeat: null,
      error: null,
    }
  },
  computed: {
    isProvider() {
      return this.firebaseUser.providerData[0].providerId !== 'password'
    },
  },
  watch: {
    newPassword() {
      this.newPasswordRepeat = null
    },
    loading: {
      handler() {
        this.myLoading = this.loading
      },
      immediate: true,
    },
    myLoading() {
      this.$emit('update:loading', this.myLoading)
    },
  },
  methods: {
    ...mapActions({ updateUsersInfo: 'UPDATE_USERS_INFO' }),
    changePassword() {
      this.changingPassword = true
    },
    resetPasswordForm() {
      this.changingPassword = false
      this.newPassword = null
      this.newPasswordRepeat = null
      this.error = null
    },
    async updatePassword() {
      if (this.isProvider) return
      if (this.newPassword !== this.newPasswordRepeat) {
        this.error = 'errorRepeat'
        return
      }
      this.myLoading = true
      try {
        await firebase.auth().currentUser.updatePassword(this.newPassword)
        this.$root.$snackbar.success({ text: this.$t('views.myAccount.updatePasswordOk') })
        this.resetPasswordForm()
      } catch (error) {
        this.error = error.code
        if (!this.error) {
          this.$root.$snackbar.error({ text: this.$t('views.myAccount.updatePasswordFailed') })
          this.resetPasswordForm()
        }
        this.myLoading = false
      }
      this.myLoading = false
    },
    async deleteAccount() {
      if (
        ['PLAN_PREMIUM', 'PLAN_PRO', 'PLAN_UNLIMITED', 'PLAN_CUSTOM'].indexOf(this.user.status) >
          -1 &&
        this.userAccountStripeSubscription &&
        ['active', 'trialing', 'incomplete', 'past_due'].indexOf(
          this.userAccountStripeSubscription.status
        ) > -1 &&
        !this.userAccountStripeSubscription.cancelAtPeriodEnd
      ) {
        // active subscription, so error
        this.error = 'activeSubscription'
        return
      }

      if (
        await this.$root.$confirm({
          title: this.$t('views.myAccount.deleteAccount.confirm.title'),
          message: this.$t('views.myAccount.deleteAccount.confirm.message'),
        })
      ) {
        this.myLoading = true
        try {
          const firebaseToken = await firebase.auth().currentUser.getIdToken()
          await firebase.auth().currentUser.delete()
          await deleteUser({ uid: this.user.uid, tokenExUser: firebaseToken })
          await this.updateUsersInfo()
        } catch (error) {
          if (error && error.code) {
            this.error = error.code
          } else if (error && error.data && error.data.name) {
            this.error = error.data.name
          } else {
            this.$root.$snackbar.error({ text: this.$t('views.myAccount.updatePasswordFailed') })
          }
          this.myLoading = false
        }
        this.myLoading = false
      }
    },
  },
}
</script>

<style lang="scss">
#account-profile-more {
  font-size: 13px;
}
</style>
